import { IS_LOCAL_OR_CI_CYPRESS } from '@utils/constants';
import { win } from '@utils/win';

export const TABLE_PREFERENCES_IDB_STORE = 'tablePref';
export const RECENT_SELECTIONS_IDB_STORE = 'recentSelections';

/**
 * IMPORTANT: This version number should NEVER be decreased, only increased or maintained.
 * Once a user's browser has been upgraded to a version, IndexedDB will not allow
 * opening a lower version, resulting in "VersionError: The requested version (X) is
 * less than the existing version (Y)".
 *
 * Version history:
 * - Version 1: Initial version with tablePref store
 * - Version 2: Added recentSelections store for AutoComplete recent selections feature
 *
 * Even if a feature is disabled or rolled back, the version must remain at this level
 * because some users' browsers have already upgraded. Having unused stores is harmless.
 */
const CURR_VERSION = 2;

export const SUPPORTS_IDB = 'indexedDB' in win;

/** config to save table preferences to IndexDB */
export const idbConfig = {
  databaseName: 'mastermind',
  // In cy component tests, we have to open the indexedDB first before running the test, which seems to bump the number of the version
  version: IS_LOCAL_OR_CI_CYPRESS ? CURR_VERSION + 1 : CURR_VERSION,
  stores: [
    {
      name: TABLE_PREFERENCES_IDB_STORE,
      id: { keyPath: 'objectId', autoIncrement: false },
      indices: [
        { name: 'tableName', keyPath: 'objectId', options: { unique: true } },
        { name: 'columns', keyPath: 'columns', options: { unique: false } },
      ],
    },
    {
      name: RECENT_SELECTIONS_IDB_STORE,
      id: { keyPath: 'key', autoIncrement: false },
      indices: [
        { name: 'key', keyPath: 'key', options: { unique: true } },
        {
          name: 'lastUpdated',
          keyPath: 'lastUpdated',
          options: { unique: false },
        },
      ],
    },
  ],
};
